import { useMemo } from 'react';
import { useQuery } from 'hooks';
import { useRouteMatch } from 'react-router';
import { IInvoice, IRateContract, ITransfer } from 'types';
import MarketInvoiceRate from './components/MarketInvoiceRate/MarketInvoiceRate';
import TransferOrPrebookInvoiceRate from './components/TransferOrPrebookInvoiceRate/TransferOrPrebookInvoiceRate';
import { getTransactionPageLink } from 'utils/links';

interface Props {
  prebookedRateContract: IRateContract | null;
  currency: string;
  transfer?: ITransfer | null;
  rate: number | null;
  invoiceType: IInvoice['type'];
}

const InvoiceRate: React.FC<Props> = ({
  prebookedRateContract,
  currency,
  transfer,
  rate,
  invoiceType,
}) => {
  const URLQuery = useQuery();
  const { url } = useRouteMatch();
  const showTransferRate = transfer?.rate !== undefined;
  const showPrebookedRate =
    !showTransferRate &&
    !!prebookedRateContract &&
    prebookedRateContract?.rate !== undefined;
  const showMarketRate = !showTransferRate && !showPrebookedRate;

  const prebookLink = useMemo(() => {
    if (prebookedRateContract) {
      URLQuery.append('contractId', prebookedRateContract.id);
    }
    return `${url}?${URLQuery.toString()}`;
  }, [prebookedRateContract, url, URLQuery]);

  return (
    <>
      {showTransferRate && transfer?.rate && (
        <TransferOrPrebookInvoiceRate
          rate={transfer?.rate}
          currency={currency}
          rateType="transfer"
          link={getTransactionPageLink({ transferId: transfer?.id })}
          invoiceType={invoiceType}
        />
      )}
      {showPrebookedRate && prebookedRateContract?.rate && (
        <TransferOrPrebookInvoiceRate
          rate={prebookedRateContract?.rate}
          currency={currency}
          rateType="prebook"
          link={prebookLink}
          invoiceType={invoiceType}
        />
      )}
      {showMarketRate && (
        <MarketInvoiceRate
          invoiceType={invoiceType}
          rate={rate}
          currency={currency}
        />
      )}
    </>
  );
};

export default InvoiceRate;
